(ns splash.ui.lender-portal.components.section
  (:require
    [splash.ui.lender-portal.components.mui :as mui]
    [splash.ui.lender-portal.components.theme :as theme]))

(defn section
  [header child]
  [mui/box
   [mui/paper {:sx {:py "9px"
                    :px "18px"
                    :mb "24px"
                    :backgroundColor theme/section-header-background}}
    [mui/typography {:variant :sectionTitle}
     header]]
   child])
